export default __webpack_public_path__ + "static/938-ad313566d728690d7f6b1fe310afddc3.gif";